/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {copyToClipBoard} from '@ion/core/src/utils/BrowserUtils';
import useUrl from '../../hooks/useUrl';
import {toggleUserPrompt} from '../../store/actions/user-prompt';

/**
 * React Hook to provide Function which enable user to copy the link with job id.
 *
 *  ```typescript
 *   import {useJobIdCopyToClipboard} from '@ion/applications/src/components/jobs/useJobIdCopyToClipboard';
 *
 *   const copyValuesToClipboard = useJobIdCopyToClipboard();
 * 
 *  ```
 */
export const useJobIdCopyToClipboard = () => {
  const url      = useUrl();
  const dispatch = useDispatch();

  const copyValuesToClipboard = useCallback((jobId: number) => {
    copyToClipBoard(`${url.getOrigin()}/provisioning/jobsearchengine?jobid=${jobId}`);
    dispatch(toggleUserPrompt({
      message          : translate('common:clipboard.copySuccess'),
      autoHideDuration : 1000
    }));
  }, [dispatch, url]);

  return copyValuesToClipboard;
};

export default useJobIdCopyToClipboard;
